const listeners = [];

const baseStore = {
  addChangeListener(cb) {
    const index = listeners.indexOf(cb);
    if (index < 0) {
      listeners.push(cb);
    }
  },

  removeChangeListener(cb) {
    const index = listeners.indexOf(cb);
    if (index > -1) {
      listeners.splice(index, 1);
    }
  },

  emitChange() {
    listeners.forEach(cb => cb());
  }
};

export default baseStore;
